<template>
  <div>
    <v-dialog v-model="showForm" max-width="700">
      <report-generation-request-form
        v-if="showForm"
        v-model="formData"
        :disabled="readOnly"
        @submit="submit()"
        @close-form="closeForm()"
      />
    </v-dialog>
    <v-layout mb-3>
      <v-flex xs6>
        <v-btn color="primary" @click="addNew">{{ $t('Add new') }}</v-btn>
        <v-btn color="primary" @click="getEntities()">
          {{ $t('Recargar') }}
        </v-btn>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('Search')"
          single-line
          hide-details
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs3 pr-3>
        <v-select
          v-model="filters.status"
          :label="$t('Estado')"
          :items="statusOptions"
          item-text="label"
          item-value="value"
          solo
          clearable
        ></v-select>
      </v-flex>
      <v-flex xs3 pr-3>
        <v-select
          v-model="filters.type"
          :label="$t('Tipo de informe')"
          :items="typeOptions"
          item-text="label"
          item-value="value"
          solo
          clearable
        ></v-select>
      </v-flex>
    </v-layout>

    <report-table
      :entities="entities"
      :pagination.sync="pagination"
      :loading="loading"
      @delete-item-clicked="deleteEntity($event)"
      @download-item-clicked="downloadReport($event)"
    ></report-table>
  </div>
</template>

<script>
import ReportTable from './tables/ReportTable.vue';
import ReportGenerationRequestForm from './forms/ReportGenerationRequestForm.vue';
import apiCtrl from '@/services/aru-services/aru-api.service.js';

export default {
  name: 'ReportTableContainer',
  components: { ReportTable, ReportGenerationRequestForm },
  props: {},
  data() {
    return {
      entities: [],
      showForm: false,
      formData: {
        name: null,
        type: null,
        request: {
          from: null,
          to: null,
          include_inactives: null,
          rolename: null,
          clavedat: null,
        },
      },
      loading: false,
      filters: {
        type: null,
        status: null,
      },
      search: '',
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 20, // -1 for All",
        sortBy: '',
        totalItems: 0,
      },
      typeOptions: [
        { label: 'Clientes en aplifisa', value: 'aplifisa-clients' },
        { label: 'Consultores asignados', value: 'assigned-consultants' },
        { label: 'Autónomos: Ingresos gastos y beneficios', value: 'igb-autonomos' },
        { label: 'Autónomos: Facturas', value: 'invoices-autonomos' },
        { label: 'Sociedades: Ingresos gastos y beneficios', value: 'igb-empresas' },
        { label: 'Sociedades: Asientos contables', value: 'seats-empresas' },
        { label: 'Pérdidas y Ganancias', value: 'pyg' },
        { label: 'Conversaciones por consultor ', value: 'threads-consultant-report' },
        { label: 'Usuarios y roles', value: 'users' },
      ],
      statusOptions: [
        { label: 'Solicitado', value: 'requested' },
        { label: 'En proceso', value: 'processing' },
        { label: 'Procesado', value: 'processed' },
        { label: 'Con errores', value: 'file_error' },
      ],
    };
  },
  mounted() {
    this.getEntities();
  },
  computed: {
    currentPage() {
      return this.pagination.page;
    },
    perPage() {
      return this.pagination.rowsPerPage;
    },
    sortBy() {
      return this.pagination.sortBy;
    },
    descending() {
      return this.pagination.descending;
    },
    filterStr() {
      return [this.filters.type, this.filters.status].join('-');
    },
  },
  methods: {
    closeForm() {
      this.showForm = false;
      this.readOnly = false;
    },
    addNew() {
      this.readOnly = false;
      this.formData = {
        name: null,
        type: null,
        request: {
          from: null,
          to: null,
          include_inactives: null,
          rolename: null,
          clavedat: null,
        },
      };
      this.showForm = true;
    },
    submit() {
      this.saveEntity();
    },
    saveEntity() {
      this.savingData = true;
      apiCtrl
        .post('/report-generation-requests', this.formData)
        .then(() => {
          this.getEntities();
          this.savingData = false;
          this.showForm = false;
          this.$emit('entity-saved', this.formData);
        })
        .catch(() => {
          this.savingData = false;
        });
      console.log(this.formData);
    },
    // updateEntity() {
    //   this.savingData = true;
    //   if (!this.adminView) {
    //     this.formData.readed = false;
    //   }
    //   apiCtrl
    //     .put('/laboral-requests/' + this.formData.id, this.formData)
    //     .then(() => {
    //       this.getEntities();
    //       this.showForm = false;
    //       this.$emit('entity-saved', this.formData);
    //     })
    //     .catch(() => {
    //       this.savingData = false;
    //     });
    //   console.log(this.formData);
    // },
    async deleteEntity(entity) {
      const res = await apiCtrl.delete('/report-generation-requests/' + entity.id);
      await this.getEntities();
      return res;
    },
    async downloadReport(entity) {
      const res = await apiCtrl.downloadBlob(`/report-generation-requests/${entity.id}/download`, {
        params: {
          name: entity.name,
          extension: 'csv',
        },
      });

      return res;
    },
    getChangeStr() {
      return [
        this.pagination.descending,
        this.pagination.page,
        this.pagination.rowsPerPage,
        this.pagination.sortBy,
        this.pagination.totalItems,
        this.search,
        this.filterStr,
      ].join('-');
    },
    async getEntities() {
      this.loading = true;

      const config = {
        params: this.getQueryParams(),
      };

      const res = await apiCtrl.get('/report-generation-requests', config);

      this.pagination = {
        descending: this.pagination.descending,
        page: res.data.meta.current_page,
        rowsPerPage: Number(res.data.meta.per_page), // -1 for All",
        sortBy: this.pagination.sortBy,
        totalItems: Number(res.data.meta.total),
      };

      this.entities = res.data.data;
      this.loading = false;

      return res;
    },

    async getEntitiesIfStopChanging() {
      const initialStr = this.getChangeStr();

      setTimeout(() => {
        const compareStr = this.getChangeStr();
        if (initialStr === compareStr) {
          this.getEntities();
        }
      }, 300);
    },

    getQueryParams() {
      let params = {
        page: this.pagination.page,
        per_page: this.pagination.rowsPerPage,
      };

      if (this.pagination.sortBy) {
        params['sort_by'] = this.pagination.sortBy;
      }
      if (this.pagination.descending) {
        params['descending'] = this.pagination.descending;
      }
      if (this.search) {
        params['custom_search'] = this.search;
      }

      Object.keys(this.filters).forEach(filterKey => {
        if (this.filters[filterKey]) {
          params[filterKey] = this.filters[filterKey];
        }
      });

      if (this.status) {
        params['status'] = this.status;
      }

      return params;
    },
  },
  watch: {
    search: function() {
      if (this.currentPage === 1) {
        this.getEntitiesIfStopChanging();
      } else {
        this.pagination.page = 1;
      }
    },
    filterStr: function() {
      if (this.currentPage === 1) {
        this.getEntitiesIfStopChanging();
      } else {
        this.pagination.page = 1;
      }
    },
    currentPage: function() {
      this.getEntitiesIfStopChanging();
    },
    perPage: function() {
      if (this.currentPage === 1) {
        this.getEntitiesIfStopChanging();
      } else {
        this.pagination.page = 1;
      }
    },
    sortBy: function() {
      this.getEntitiesIfStopChanging();
    },
    descending: function() {
      this.getEntitiesIfStopChanging();
    },
  },
};
</script>

<style></style>
